import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';
import './Contact.css';

const Contact = () => {
  return (
    <div className="page-container">
      <SEO page="contact" />
      <Header />
      <main className="main-content full-width">
        <section className="contact-section">
          <h2>联系我们</h2>
          <div className="contact-info">
            <div className="info-item">
              <h3>地址</h3>
              <p>成都市天鹅湖社区百悦锦城18栋1单元701室</p>
            </div>
            <div className="info-item">
              <h3>电话</h3>
              <p>18512815101</p>
            </div>
            <div className="info-item">
              <h3>邮箱</h3>
              <p>769018240@qq.com</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Contact;
